var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-sample-detail',{staticClass:"pt-sample-detail__withData",attrs:{"data":_vm.data,"order":_vm.order,"id":_vm.id,"bill":_vm.bill},on:{"load":_vm.getSampleDetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }